var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_vm._v("\n    This page is a stub for a feature not yet implemented\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }